<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <form>
            <v-card color= "grey lighten-5">
             <v-flex xs12 sm12>
            <v-toolbar  size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
        </v-flex>
              <v-card-text>
<v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                  <v-layout wrap>
                                         <div class="flex md12">

                      <div v-show="codegorunum === true ">
                        <v-text-field label="Referans Kodu" :color="color" v-model="Referans.Kod" :error-messages="errors.collect('Referans.Kod')" v-validate="'required|max:100'"
                          data-vv-name="Referans.Kod" required></v-text-field>
                      </div>

                      <v-text-field label="Referans Adı" :color="color" v-model="Referans.ReferansAd" :error-messages="errors.collect('Referans.ReferansAd')"
                        v-validate="'required|max:100'" data-vv-name="Referans.ReferansAd" required></v-text-field>
                                         </div>
                  </v-layout>
                   </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <div v-show="m === true">
                  <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                  <v-btn id="bsil" color="blue darken-1" flat @click="deletereferans()">Sil</v-btn>
                </div>
                <div v-show="k === true">
                  <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
                </div>
                <v-btn color="blue darken-1" flat @click.native="dialog = false">Vazgeç</v-btn>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar   size="120px" dark color="info">
          <v-toolbar-title class="baslikfont">Referans</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn flat @click="referansekle()"> Referans Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>



      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
                        <v-progress-linear slot="progress"   indeterminate></v-progress-linear>


          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item.Kod)" item>
              <td class="text-xs-left">{{ props.item.KayitTarihi }}</td>
              <td class="text-xs-left">{{ props.item.Kod }}</td>
              <td class="text-xs-left">{{ props.item.ReferansAd }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>
      <template>
        <v-card>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'
  import VeeValidate from '../../../../node_modules/vee-validate'
  import Vue from 'vue'
  Vue.use(VeeValidate)

  export default {
    data() {
      return {
        headers: [{
            text: 'Kayıt Tarihi',
            value: 'KayitTarihi'
          },
          {
            text: 'Referans Kodu',
            value: 'Kod'
          },
          {
            text: 'Referans Adı',
            value: 'ReferansAd'
          },
        ],
        items: [],
                color:'orange darken-4',

        selected: '',
        search3: '',
        m: false,
        k: false,
        dialog: false,
        Referans: {
          KayitTarihi: '',
          Kod: '',
          ReferansAd: '',
          SirketKodu:''
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress:false,
      }
    },
    mounted() {
      this.$validator.localize('tr', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Referans Güncelle'
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      SirketKodu:credentials.SirketKodu,
          Kod: v
        }
        this.$http.post(auth.API_URL + 'api/Reference/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Referans = response.body[0]
        })
      },
      deletereferans: deletereferans,
      referansekle: referansekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      SirketKodu:credentials.SirketKodu,
}
this.Referans.SirketKodu= credentials.SirketKodu
        var params = this.Referans
        this.$http.post(auth.API_URL + 'api/Reference/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Reference/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                 this.text1 = 'Service Unavailable'
              this.snackbar = true
              } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true              }
            })
          } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true          }
        }, (response) => {
          if (response.status === 0) {
     this.text1 = 'Service Unavailable'
              this.snackbar = true          } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true          }
        })
      }
    })
  }

  function referansekle() {
    this.$validator.reset()
    this.dialog = true
    this.Referans.ReferansAd = ''
    this.Referans.Kod = ''
    this.dialog_baslik = 'Referans Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {

var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      SirketKodu:credentials.SirketKodu,
}

    this.progress=true
    this.$http.post(auth.API_URL + 'api/Reference/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress=false
      this.items = response.body
    }, (response) => {
      if (response.status === 0) {
     this.text1 = 'Service Unavailable'
              this.snackbar = true      } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true      }
    })
  }

  function deletereferans() {

    if (window.confirm('Referans\'ı silmek istediğinizden eminmisiniz?')) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      SirketKodu:credentials.SirketKodu,
}
this.Referans.SirketKodu=credentials.SirketKodu


      var params = this.Referans

      this.$http.post(auth.API_URL + 'api/Reference/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/Reference/List',params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = 'Silme işlemi tamamlandı'
            this.snackbar = true

          }, (response) => {
            if (response.status === 0) {
     this.text1 = 'Service Unavailable'
              this.snackbar = true
                 } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true            }
          })
        } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true        }
      }, (response) => {
        if (response.status === 0) {
     this.text1 = 'Service Unavailable'
              this.snackbar = true        } else {
     this.text1 = 'Service Unavailable'
              this.snackbar = true        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      SirketKodu:credentials.SirketKodu,
}
this.Referans.SirketKodu=credentials.SirketKodu
        var params = this.Referans
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Reference/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/Reference/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>

</style>